module.exports = __webpack_public_path__ + "img/magento-custom-development.9fee6d73.webp";